import logger from './../utils/logger.js';

// src/MCQComponent/MCQLayout.jsx
import React, { useState, useEffect } from 'react';
import { useWebSocket } from '../WebSocketContext';
import { Volume2 } from 'lucide-react';

const MCQLayout = ({
  handleSubmitMCQ,
  interviewId,
  currentQuestionIndex,
  totalQuestions,
}) => {
  const { isMCQDataAvailable, sendSkipRequest } = useWebSocket();
  const [selectedOption, setSelectedOption] = useState(null);
  const [open, setOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastSeverity, setToastSeverity] = useState("success");
  const [isSubmitted, setIsSubmitted] = useState(false);
logger.debug("isMCQDataAvailable", isMCQDataAvailable,currentQuestionIndex,totalQuestions);
  // Reset all states when question changes or on unmount
  useEffect(() => {
    setSelectedOption(null);
    setIsSubmitted(false);
    setOpen(false);
    setToastMessage("");
    return () => {
      setSelectedOption(null);
      setIsSubmitted(false);
      setOpen(false);
      setToastMessage("");
    };
  }, [isMCQDataAvailable?.id]);

  const handleCheckboxChange = (index) => setSelectedOption(index);

  const handleSubmit = async () => {
    const payload = {
      interview_id: interviewId,
      question_id: isMCQDataAvailable?.id,
      question: isMCQDataAvailable?.message,
      answer: selectedOption + 1,
    };
    await handleSubmitMCQ(payload).then((res) => {
      if (res) {
        setIsSubmitted(true);
      }
    });
  };

  const handleSkip = () => {
    sendSkipRequest({ isSubmitted });
    setToastMessage("Question skipped successfully");
    setOpen(true);
    if (isSubmitted) {
    }
  };

  const handleClose = () => setOpen(false);


  return (
   <div className="items-start bg-white text-gray-900 rounded-xl w-full max-w-[100%] mx-auto border border-gray-200 shadow-sm">
  {/* Main MCQ Card */}
  <div className="relative w-full max-w-[100%] mx-auto bg-white rounded-xl p-6 border border-gray-200 space-y-6 z-10 min-h-[50vh] ">
    
    <div className='flex flex-col itmes-center justify-start gap-4'>
      {/* Question Counter + Progress Label */}
    <div className="flex justify-between items-center  font-medium text-gray-600 mb-0">
      <span className="text-black-500 text-md font-semibold">
        Question {currentQuestionIndex } of {totalQuestions}
      </span>
      {/* <span className="text-xs tracking-wider uppercase text-gray-400">Progress</span> */}
    </div>

    {/* Progress Bar */}
    <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
      <div
        className="h-full bg-blue-300 rounded transition-all duration-300 ease-in-out"
        style={{
          width: `${((currentQuestionIndex ) / totalQuestions) * 100}%`
        }}
      ></div>
    </div>
    </div>

    {/* Header */}
    <div className="flex justify-between items-center border-b border-gray-200  pb-6">
      <div>
        <h2 className="text-xl font-semibold text-gray-900 mt-1">
          {isMCQDataAvailable?.message}
        </h2>
      </div>
    </div>

    {/* Options */}
    
    {/* Options */}
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-12">
      {isMCQDataAvailable?.mcq_options?.map((option, index) => (
  <label
    key={index}
    onClick={() => handleCheckboxChange(index)}
    className={`relative flex items-center gap-4 p-4 rounded-xl cursor-pointer transition-all duration-300 shadow-sm border-2
      ${
        selectedOption === index
          ? "bg-blue-50 border-blue-500 ring-1 ring-blue-300"
          : "bg-white border-gray-200 hover:border-blue-300 hover:shadow"
      }`}
  >
    {/* Hidden checkbox for accessibility */}
    <input
      type="radio"
      checked={selectedOption === index}
      onChange={() => handleCheckboxChange(index)}
      className="hidden"
    />

    {/* A/B/C/D Label */}
    <div className={`flex items-center justify-center w-8 h-8 rounded-full text-sm font-bold
      ${
        selectedOption === index
          ? "bg-blue-600 text-white"
          : "bg-gray-200 text-gray-700"
      }`}
    >
      {String.fromCharCode(65 + index)}
    </div>

    {/* Option Text */}
    <span className="text-sm sm:text-base text-gray-800">{option}</span>
  </label>
))}
    </div>  

    {/* CTA Buttons */}
  <div className="flex justify-end items-center gap-x-8 pt-8">
  {/* Skip Button */}
  <button
    onClick={handleSkip}
    className="flex items-center justify-center gap-4 px-6 py-3 text-base font-semibold rounded-md  text-white-700 bg-gray-100 border border-gray-300 shadow-sm hover:bg-blue-500 hover:shadow-md transition duration-200 ease-in-out active:scale-95 transform"
  >
    Skip
  </button>

  {/* Submit Button */}
  <button
    disabled={selectedOption === null || isSubmitted}
    onClick={handleSubmit}
    className={`flex items-center justify-center gap-2 px-8 py-3 text-base font-bold rounded-md transition duration-200 ease-in-out transform
      ${
        selectedOption === null || isSubmitted
          ? "bg-gray-200 text-gray-400 cursor-not-allowed"
          : "bg-blue-600 text-white hover:bg-blue-500 hover:shadow-md active:scale-95"
      }`}
  >
    {isSubmitted ? "Submitted" : "Submit"}
  </button>
</div>
  </div>
  {/* Toast Notification */}
  {open && (
    <div
      className={`fixed bottom-6 right-6 z-50 px-4 py-3 rounded-lg shadow-md flex items-center gap-3 w-[300px] transition-transform duration-300 transform ${
        toastSeverity === "info"
          ? "bg-blue-50 border border-blue-200"
          : "bg-green-50 border border-green-200"
      }`}
    >
      <div className="flex-1 text-sm  font-medium text-black font-bold leading-none tracking-wider ">{toastMessage}</div>
      <button
        onClick={handleClose}
        className="text-xl font-bold leading-none text-gray-400 hover:text-gray-700"
      >
        ×
      </button>
    </div>
  )}
</div>
  );
};

export default MCQLayout;